/**
 文件：src/utils/backend.vue
 作者：陈凯
 时间：2020-04-23
 描述：请求后端的工具
 */

import axios from 'axios';
import store from '@/store'
import router from '@/router'
import qs from 'qs'


import { message } from 'ant-design-vue';
import { loginURL } from "../../vue.dev";
const { endServers } = require('../../vue.dev');

let mAxiosHandler = null;

/**
 * 读取api配置
 * @param {*} value
 */
function getApiConf(value) {
    if (!value) {
        throw new Error('Api path is null');
    }
    let server = 'hlw'
    if (process.env.PATH_ENV == "build") {
        server = 'zwww'
    }
    if (typeof(value) === 'string') {
        return {
            path: value,
            method: 'GET',
            server,
        }
    } else {
        if (!value) {
            throw new Error('Api未配置' + JSON.stringify(value));
        }
        if (typeof(value) !== 'object') {
            throw new Error('Api配置错误' + JSON.stringify(value));
        }
        if (!value.method) {
            throw new Error('Api配置错误，缺少method属性' + JSON.stringify(value));
        }
        if (!value.path) {
            throw new Error('Api配置错误，缺少path属性' + JSON.stringify(value));
        }
        if (!value.isFormData) {
            value.isFormData = false
        }
        if (!value.isBolb) {
            value.isBolb = false
        }

        return {
            path: value.path,
            method: value.method.toLowerCase(),
            server: value.server || server,
            isFormData: value.isFormData,
            isBolb: value.isBolb
        };
    }
}

/**
 * 根据api.path获取完整的url
 * @param {*} api
 */
function getUrl(api) {
    return `${api.server}${api.path}`
}

/**
 * 构建url参数
 * @param {*} json
 */

function buildQuery(json) {
    if (!json) {
        return '';
    }
    let query = '?';
    let paramConcat = '&';
    for (let i in json) {
        query += (i + '=' + encodeURIComponent(json[i]) + paramConcat)
    }
    if (query.charAt(query.length - 1) === paramConcat) {
        query = query.substr(0, query.length - 1);
    }
    return query;
}


/**
 * 发送http请求
 * @param {*} settings
 */
function request(settings) {
    let { api, data, options = {}, query, restful = true, isMessageError } = settings
    api = getApiConf(api);
    let url = getUrl(api);
    let isFormData = api.isFormData // true 表单类型，false对象类型
    let isBolb = api.isBolb

    let isDataAsQuery = (api.method === 'get' || api.method === 'delete') && !query && data;
    if (isDataAsQuery) {
        query = data;
    }
    // 把我们的数据添加到这个 FormData 对象中
    if (isFormData) {
        data = qs.stringify(data)
    }
    let params = null;
    if (restful) {
        params = query;
    } else {
        url += buildQuery(query)
    }
    let axios = createAxiosInstance({
        url,
        responseType: isBolb ? 'blob' : settings.responseType,
        params,
        isFormData,
        data,
        options,
        isBolb,
    })

    if (isMessageError && typeof mAxiosHandler === 'function') {
        mAxiosHandler(axios, settings)
    }
    return new Promise((resolve, reject) => {
        axios.request({
            method: api.method,
            data: data,
            params: params,
        }).then(response => {
            // 此处一定要做判断，因为拦截器可能什么也没有返回
            if (response) {
                const res = response.data
                if (res.code == 200) {
                    resolve(res.result);
                } else if (res.code == 500) {
                    //登录失效
                    convertErrorMsg(res.code, res.msg)
                    if (res.result === '该票据不存在或已过期' || res.result === '令牌已失效') {
                        // store.dispatch('getToken');
                        // message.warning(res.result);
                        store.dispatch('logout')
                        if (process.env.PATH_ENV !== 'dev') `${loginURL}&gotoUrl=${common_tool.windowUrl()}`
                    }
                } else if (res.code == 11002 || res.code == 403) {
                    //登录失效
                    store.dispatch('removeToken')
                    convertErrorMsg(res.code, '登录过期请重新登录！')
                } else if (response.status === 200 && response.data) {
                    resolve(response.data);
                } else {
                    resolve(res.result);
                    convertErrorMsg(res.code, res.msg)
                }

            }
        }).catch(error => {
            store.dispatch('removeToken')
            store.dispatch('getToken')
            reject(error);
            convertError(error, '登录过期请重新登录！')
                //   router.push('/')
        })
    })
}

/**
 * 创建axios实例
 * @param {
 *  url 请求基地址
 *  options http请求头参数
 *  params 请求参数拼接在url上面
 *  data 请求参数放请求体里
 * }
 */
function createAxiosInstance({ url, responseType, params, data, isFormData, options, isBolb }) {
    const headers = {
        "app-version": APP_INFO.version,
        "app-version-build": "1",
        "app-os": "web",
        "app-os-version": APP_INFO.version,
        "app-device-model": "web",
        "token": common_tool.getDataFromLocal('token'),
        "Authorization": 'Bearer ' + common_tool.getDataFromLocal('token'),
        "platform": "web",
        'Content-Type': isFormData ? 'application/x-www-form-urlencoded' : 'application/json',
    }
    return axios.create({
        baseURL: url,
        timeout: 100000, // 请求超时时长
        headers: Object.assign({
            ...headers
        }, options),
        responseType: isBolb ? 'blob' : responseType | 'json',
        params: params || {},
        data: data,
        xhrFields: {
            responseType: isBolb ? 'blob' : '',
        },
    })
}

function convertError(error) {
    let response = error.response;
    if (response) {
        convertErrorMsg(response.status)
    } else {
        message.warning('无法连接服务器，请检查您的网络');
    }
}

function convertErrorMsg(status, msg, result) {
    if (status === 504) {
        msg = msg || '服务器网关超时，请联系管理员!';
    } else if (status === 404) {
        msg = msg || '服务未启动或未找到接口!';
    } else {
        msg = msg || '服务器繁忙，请稍后再试!';
    }
    message.warning(msg);
}

/**
 * 请求代理类
 */
export default {
    /**
     * 获取url
     */
    // getUrl(apiKey, data) {
    //   let api = getApiConf(apiKey);
    //   let url = getUrl(api);
    //   if (typeof data === 'object') {
    //     url += buildQuery(data);
    //   }
    //   return url;
    // },
    getUrl(apiKey, data) {
        let api = getApiConf(apiKey);
        let url = endServers[api.server];
        if (typeof data === 'object') {
            url += buildQuery(data);
        }
        return url + '/';
    },

    /**
     * 请求后端
     * @param api 获取URL用，即定义在src/conf/api.js中的api的Key
     * @param data JSON数据
     * @param options ajax附件参数，主要是http header，用的比较少
     * @param isMessageError 当出现错误，是否弹窗提示
     * @returns {*}
     */
    request(api, data, options, isMessageError = true) {
        console.log(data)
        return request({
            api,
            data,
            options,
            isMessageError
        })
    },

    /**
     * @param {
     * 	api: '' // piKey 获取URL用，即定义在src/conf/api.js中的api的Key
     *  data: JSNO对象，POST或者PUT到服务端的JOSON数据，如果是GET或者Delete则实际转换成url参数
     *  query: FormData
     * }
     */
    send(settings) {
        return request(settings);
    },
    setAxiosHandler(handler) {
        mAxiosHandler = handler;
    },

    /**
     * 转换错误
     * @param {*} error
     */
    convertError(error) {
        let ret = { code: -1 };
        let response = error.response;
        if (response) {
            ret.code = response.status;
            let url = response.config.url;
            if (response.status === 504) {
                ret.msg = '服务器网关超时，请联系管理员，请求：' + url;
            } else if (response.status === 404) {
                ret.msg = '服务未启动或未找到接口，请求：' + url;
            } else {
                ret.msg = '服务器繁忙，请稍后再试，请求：' + url;
            }
        } else {
            ret.msg = '无法连接服务器，请检查您的网络';
        }
        return ret;
    },
}


// WEBPACK FOOTER //
// ./src/conf/backend.js